import { render, staticRenderFns } from "./cadexercicios.vue?vue&type=template&id=0ad28e66&"
import script from "./cadexercicios.vue?vue&type=script&lang=js&"
export * from "./cadexercicios.vue?vue&type=script&lang=js&"
import style0 from "./cadexercicios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports